import { UserParticipant } from "./UserParticipant";

export class MatrixParticipant extends UserParticipant {
    /**
     * 用于存储字段id
     */
    matrixDefId: string;
    matrixDefName: string;
    conditionField1: string;
    conditionFieldText1: string;
    conditionField2: string;
    conditionFieldText2: string;
    conditionField3: string;
    conditionFieldText3: string;
    multivaluedCondition: string;
    dataFieldAlias: string;
}